import * as React from 'react';

import { emptyArray } from 'bones/constants/empty';
import { SelectItem } from 'bones/design-system/utils/select/types';
import { usePortalConnections } from 'bones/utils/portal/usePortalConnections';
import { usePortalDemoConnection } from 'bones/utils/portal/usePortalDemoConnection';

export interface PortalConnectionItem extends SelectItem {
  index: number;
}

export const usePortalConnectionItems = (connectionIdx?: number) => {
  const connections = usePortalConnections();
  const demoConnection = usePortalDemoConnection();

  const connectionItems = React.useMemo(() => {
    if (!connections.data) {
      return emptyArray as any as PortalConnectionItem[];
    }
    return connections.data.map<PortalConnectionItem>((connection) => ({
      index: connection.index,
      text: connection.name,
      value: connection.id,
    }));
  }, [connections]);

  const connectionItem = React.useMemo(() => {
    const itemsWithDemo = demoConnection.data
      ? [
          ...connectionItems,
          {
            index: demoConnection.data.index,
            text: demoConnection.data.name,
            value: demoConnection.data.id,
          },
        ]
      : connectionItems;
    return itemsWithDemo.find((item) => item.index === connectionIdx) || null;
  }, [connectionIdx, connectionItems, demoConnection.data]);

  return { connections, connectionItems, connectionItem };
};
